<template>
  <el-dialog
    title="切换企业"
    :visible.sync="dialogVisible"
    width="600px"
    :append-to-body="true"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="enterprise-list">
      <div 
        class="enterprise-item" 
        v-for="(item, index) in enterpriseList" 
        :key="index"
      >
        <div class="enterprise-info">
          {{ item.companyName }}
          <el-tag v-if="item.isChoose === '1'" size="mini" type="success" style="margin-left: 10px;">当前</el-tag>
        </div>
        <el-button v-if="item.isChoose !== '1'" type="text" icon="el-icon-refresh" :loading="switchLoading === item.guid" @click="handleSwitch(item)" style="color: #2674B4;">切换</el-button>
      </div>
      <div class="enterprise-item add-new" @click="handleAddEnterprise">
        <div class="enterprise-info">
          <i class="el-icon-plus"></i> 新的公司
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { registerInfoList, registerInfoSwitch } from '@/api/registerFile'

export default {
  name: 'SwitchEnterpriseDialog',
  data() {
    return {
      dialogVisible: false,
      enterpriseList: [],
      currentCompany: '',
      switchLoading: ''
    }
  },
  methods: {
    open(currentCompany) {
      this.currentCompany = currentCompany || '';
      this.dialogVisible = true;
      this.fetchEnterpriseList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async fetchEnterpriseList() {
      try {
        const res = await registerInfoList();
        this.enterpriseList = res || [];
      } catch (error) {
        console.error(error);
      }
    },
    async handleSwitch(item) {
      if (!item.guid) {
        this.$message.warning('该企业无法切换');
        return;
      }
      this.switchLoading = item.guid;
      try {
        const result = await registerInfoSwitch({ guid: item.guid }) || {};
        this.$message.success('切换成功');
        this.$emit('switch-success', item.companyName);
        this.dialogVisible = false;
        // 需要更新本地存储的userInfo信息
        this.$store.dispatch("user/switchCompany", {
          isAdmin: result.isAdmin,
          cpyName: result.cpyName,
          step: result.step,
          role: result.role,
          guid: result.guid
        })
      } catch (error) {
        console.error(error);
      } finally {
        this.switchLoading = '';
      }
    },
    handleAddEnterprise() {
      this.dialogVisible = false;
      this.$router.push('/intserv/register/index?type=add');

    }
  }
}
</script>

<style scoped lang="scss">
.enterprise-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.enterprise-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  transition: all 0.3s;
  
  &:hover {
    border-color: #2674B4;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  }
  
  &.add-new {
    justify-content: center;
    color: #2674B4;
    border-style: dashed;
    cursor: pointer;
    
    .enterprise-info {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}
</style>
